import React, { useEffect, useRef } from 'react';
import Banner from '../../b2b-common/Banner';
import MeasurementUnit from '../components/MeasurementUnit';
import MeasurementUnitsTable from '../components/MeasurementUnitsTable';

import './ListMeasurementUnits.css';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const ListMeasurementUnits = () => {

    const { t } = useB2BTranslation();
    const [selectedMeasurementUnit, setSelectedMeasurementUnit] = React.useState(null);

    const measurementUnitRef = useRef({});
    const scrollToMeasurementUnit = () => {
        setTimeout(() => {
            if (measurementUnitRef.current instanceof HTMLElement) {
                measurementUnitRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }, 0); // This is done to ensure that the scrollIntoView function is called after any potential re-renders of the component
    }

    useEffect(() => {
        scrollToMeasurementUnit()
    }, [selectedMeasurementUnit]);

    const handleSelectMeasurementUnit = (unitObject) => {
        if (selectedMeasurementUnit !== unitObject) {
            //console.log('Selected measurement unit:', unitObject);
            setSelectedMeasurementUnit(unitObject);
        }
    }

    return (
        <div className='list-measurement-units-container'>
            <Banner sectionTittle={t('Indicators')} message={t('List measurement units.')} />
            <MeasurementUnitsTable
                onSelectedMeasurementUnit={handleSelectMeasurementUnit}
            />
        </div>
    );
};

export default ListMeasurementUnits;